// src/AppRouter.jsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FormPage from '../components/FormPage';
import ImageSelectionPage from '../components/ImageSelectionPage';
import DataTablePage from '../components/DataTablePage';
import SuccessPage from '../components/SuccessPage'; // Import SuccessPage

function AppRouter() {
  const [formData, setFormData] = useState({});

  return (
    <Router>
      <Routes>
        <Route path="/" element={<FormPage setFormData={setFormData} />} />
        <Route path="/select-image" element={<ImageSelectionPage formData={formData} />} />
        <Route path="/data-table" element={<DataTablePage />} />
        <Route path="/success" element={<SuccessPage />} /> {/* Route for SuccessPage */}
      </Routes>
    </Router>
  );
}

export default AppRouter;
